import React from 'react';

export default function arrowLeft(props: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <path
        d="M-9.53674e-07 9.5L15 18.1603L15 0.839746L-9.53674e-07 9.5ZM15 8H13.5V11H15V8Z"
        fill="#6C757D"
      />
    </svg>
  );
}
